<script>
export default {
  name: 'dependent',
  props: {
    dependent: {
      type: Object,
      require: true
    }
  }
}
</script>

<template lang="pug">
  .white-bg.list-item
    .row.border-bottom
      h4.col-xs-7 {{ dependent.name }}
      .col-xs-5
        .exclude-list(@click.prevent="$emit('on-delete', dependent)")
          span.icon 
        router-link(:to="{name: 'settings.dependents.edit', params: {id: dependent.id}}")
          a(href='')
            .edit-list
              span.icon 
    .list-info
      template(v-if="dependent.degree")
        strong Grau de Parentesco: &nbsp;
        | {{ dependent.degree.name }}
      br
      router-link(:to="{name: 'settings.dependents.edit', params: {id: dependent.id}}")
       strong Idade: &nbsp;
       |{{ dependent.age }}
</template>



// WEBPACK FOOTER //
// src/app/settings/dependents/index/components/dependent.vue